import Collection from './collection';
import _Manager from './manager';

export { defaultDefaultState, useManager } from './collection';
export const Manager = _Manager;
export default Collection;
